import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShift: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shift"} maskId="square-filled-radius-0-stroke-1-IconShift"><path d="M12.0014 1.75671L0.871094 14H6.00137V21H18.0014V14H23.1316L12.0014 1.75671Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShift;
